import { Einheit } from 'app/models/core/einheit.model';
import { BnrGpPosModel } from '../bnr.gp.pos.model';
import { PosUnDef } from '../gp';

const posDef: BnrGpPosModel[] = [];

posDef.push(new BnrGpPosModel({ year: 2025, posId: 2217001, group: 'vss', posText: 'Weiterbildung IDD ', planKey: 'idd', einheit: Einheit.stck }));
posDef.push(new BnrGpPosModel({ year: 2025, posId: 2217010, group: 'vss', posText: 'Fzg. in Kleinflotten + FPM', einheit: Einheit.stck }));
posDef.push(new BnrGpPosModel({ year: 2025, posId: 2217030, group: 'vss', posText: 'Unternehmensschutz', einheit: Einheit.stck }));
posDef.push(new BnrGpPosModel({ year: 2025, posId: 2217035, group: 'vss', posText: 'Unfall Anschlussgeschäft', einheit: Einheit.bew }));

posDef.push(new BnrGpPosModel({ year: 2025, posId: 2217041, group: 'eh', posText: 'Sach Firmen', einheit: Einheit.bew }));
posDef.push(new BnrGpPosModel({ year: 2025, posId: 2217042, group: 'eh', posText: 'Unfall Bew o. Anp.', planKey: 'unfallbew', einheit: Einheit.bew }));

posDef.push(new BnrGpPosModel({ year: 2025, posId: 2217111, group: 'neh', posText: 'Firmen Sach o. Kr. Bew', planKey: 'fsachokraftoanpbew', einheit: Einheit.bew }));
posDef.push(new BnrGpPosModel({ year: 2025, posId: 2217121, group: 'neh', posText: 'Firmen Kraft Bew', einheit: Einheit.bew }));
posDef.push(new BnrGpPosModel({ year: 2025, posId: 2217131, group: 'neh', posText: 'Firmen Rechtsschutz', einheit: Einheit.bew }));
posDef.push(new BnrGpPosModel({ year: 2025, posId: 2217141, group: 'neh', posText: 'Firmen Sach o.Kr. BZUW-Beitrag', einheit: Einheit.bew }));
posDef.push(new BnrGpPosModel({ year: 2025, posId: 2217150, group: 'neh', posText: 'Unfall Bew o. Anp. (Digi)', planKey: 'unfallbew', einheit: Einheit.bew }));
posDef.push(new BnrGpPosModel({ year: 2025, posId: PosUnDef, group: 'neh', posText: 'Unfall Anschluss (Potenzial)', einheit: Einheit.bew }));

posDef.push(new BnrGpPosModel({ year: 2025, posId: 3817022, group: 'gpplus', posText: 'Zuwachs Stück ', einheit: Einheit.bew }));

export const LbsgPositionen = posDef;
